import {rootState} from '@mintdata-wsp/common/state/RootState';
import {SurfaceDragContext, SurfaceGlassState} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {action} from 'mobx';

export class SurfaceGlassController
{
    @action
    public setDragContext(ctx:SurfaceDragContext):void
    {
        const state:SurfaceGlassState = this._getState();

        state.dragContext = ctx;
    }

    @action
    public enableReparenting():void
    {
        const state:SurfaceGlassState = this._getState();

        state.isReparentingEnabled = true;
    }

    @action
    public disableReparenting()
    {
        const state:SurfaceGlassState = this._getState();

        state.isReparentingEnabled = false;
    }

    public getDragContext():SurfaceDragContext
    {
        const state:SurfaceGlassState = this._getState();

        return state.dragContext;
    }

    public isDraggingComponent():boolean
    {
        const state:SurfaceGlassState = this._getState();

        return !!state.dragContext;
    }

    public isReparentingComponent():boolean
    {
        const state:SurfaceGlassState = this._getState();

        return !!state.dragContext && state.isReparentingEnabled;
    }

    public _getState():SurfaceGlassState
    {
        return rootState.ui.visualDesigner.surfaceEditor.glass;
    }
}
